import { SCREEN_SHARE } from 'constants/DirectorControls';
/**
 * Knock request status
 */
export const PENDING = 'pending';

/**
 * Knock request type
 */
export const PRESENTER_KNOCK = 'presenter';
export const SCREENSHARE_KNOCK = 'screenshare';

/**
 * Request type to knock type
 */
export const requestTypeToKnock = {
  [SCREEN_SHARE]: 'screenshare'
};

/**
 * Knock Type to control
 */
export const knockTypeToControl = {
  [SCREENSHARE_KNOCK]: SCREEN_SHARE
};
